import React from "react";
import DocumentUploadField from "../elements/document-upload-field";

export default function DeathCertificate(props: any) {
  return (
    <DocumentUploadField
      title="Death certificate or medical cause of death"
      onUploaded={props.setDeathCertificate}
    />
  );
}
